import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { getAuthenticated } from '../../utils/LocalStorage';
import LoginDialog from '../../dialogs/LoginDialog';
import UsuarioDialog from '../../dialogs/UsuarioDialog';
import SenhasDialog from '../../dialogs/SenhasDialog';
import EmailDialog, { TIPO_PAGINA } from '../../dialogs/EmailDialog';
import Logging from '../Logging';
import Status from '../Status';
import Warning from '../Warning';
import Error from '../Error';
import Documentos from '../../modelo/Documentos';
import Usuarios from '../../modelo/Usuarios';
import Campos from '../../modelo/Campos';
import PaginaSegurancaDialog, { TIPOS_PAGINA_DE_SEGURANCA } from '../../dialogs/PaginaSegurancaDialog';

export default function Main(props) {
  /*
  const [refreshHeader,setRefreshHeader] = useState(crypto.randomUUID());
  const changeHeader = () => {
    setRefreshHeader(crypto.randomUUID());
  };
  */

  const [usuarioAdministrador,setUsuarioAdministrador] = useState(false);
  const [usuarioEmail,setUsuarioEmail] = useState('');
  const [usuarioLogado,setUsuarioLogado] = useState('');

  const getUsuario = (callback) => {
    getAuthenticated(callback);
  };

  useEffect(()=>{
    getUsuario((usuario)=>{
      setUsuarioAdministrador(usuario.usuario_administrador);
      setUsuarioEmail(usuario.usuario_email);
      setUsuarioLogado(usuario.session_logado);
    });
  },[]);

  const paginaSegurancaRedefinirEmail = (props) => {
    return (
      <Route
        exact
        path="/redefinir-email/:uuid"
        element={
          <PaginaSegurancaDialog
            setLoading={props.setLoading}
            handleMessage={props.handleMessage}
            version={props.version}
            mainError={props.error}
            setError={props.setError}
            tipoPaginaSeguranca={TIPOS_PAGINA_DE_SEGURANCA.REDEFINIR_EMAIL}
            changeUsuario={props.changeUsuario}
          />
        }
      />
    );
  };

  const paginaNaoEncontrada = (props) => {
    return (
      <Route
        exact
        path="*"
        element={
          <Warning
            version={props.version}
            setLoading={props.setLoading}
            handleMessage={props.handleMessage}
            error={props.error}
            setError={props.setError}
            naoExibirMenu={true}
            mensagem="Página não encontrada!"
          />
        }
      />
    );
  };

  const paginaAcessoNegado = (path,props) => {
    return (
      <Route
        exact
        path={path}
        element={
          <Error
            version={props.version}
            setLoading={props.setLoading}
            handleMessage={props.handleMessage}
            error={props.error}
            setError={props.setError}
            naoExibirMenu={true}
            mensagem="Acesso não permitido!"
          />
        }
      />
    );
  };

  const paginaSegurancaCadastrarUsuario = (props) => {
    return (
      <Route
        exact
        path="/cadastrar-usuario/:uuid"
        element={
          <PaginaSegurancaDialog
            setLoading={props.setLoading}
            handleMessage={props.handleMessage}
            version={props.version}
            mainError={props.error}
            setError={props.setError}
            tipoPaginaSeguranca={TIPOS_PAGINA_DE_SEGURANCA.CADASTRAR_USUARIO}
            changeUsuario={props.changeUsuario}
          />
        }
      />
    );
  };

  const paginasAdministrativas = (props) => {
    return (
      <>

        {
          (usuarioEmail === 'lgapontes@gmail.com') ? (
            <>
              <Route
                exact
                path="/logging"
                element={
                  <Logging
                    version={props.version}
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    setError={props.setError}
                    error={props.error}
                  />
                }
              />

              <Route
                exact
                path="/status"
                element={
                  <Status
                    version={props.version}
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    setError={props.setError}
                    error={props.error}
                  />
                }
              />
            </>
          ) : (<></>)
        }

        {
          (usuarioAdministrador) ? (
            <>
              <Route
                exact
                path="/usuarios"
                element={
                  <Usuarios
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    mainError={props.error}
                    setError={props.setError}
                    version={props.version}
                    mobileOpen={props.mobileUsuariosOpen}
                    setMobileOpen={props.setMobileUsuariosOpen}
                  />
                }
              />

              <Route
                exact
                path="/cadastrar-usuario"
                element={
                  <EmailDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPagina={TIPO_PAGINA.CADASTRAR_USUARIO}
                  />
                }
              />

              <Route
                exact
                path="/reenviar-email/:uuid"
                element={
                  <EmailDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPagina={TIPO_PAGINA.REENVIAR_EMAIL}
                  />
                }
              />
            </>
          ) : (<></>)
        }

      </>
    );


  };

  return (
    <BrowserRouter>
      <Routes>

        {
          (!usuarioLogado) ? ( /* ACESSO LIVRE */
            <>

              <Route
                exact
                path="/"
                element={
                  <LoginDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    setError={props.setError}
                    error={props.error}
                    changeUsuario={props.changeUsuario}
                  />
                }
              />

              {
                /* /cadastrar-usuario/:uuid */
                paginaSegurancaCadastrarUsuario(props)
              }

              <Route
                exact
                path="/redefinir-senha"
                element={
                  <EmailDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPagina={TIPO_PAGINA.REDEFINIR_SENHA}
                  />
                }
              />

              <Route
                exact
                path="/redefinir-senha/:uuid"
                element={
                  <PaginaSegurancaDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPaginaSeguranca={TIPOS_PAGINA_DE_SEGURANCA.REDEFINIR_SENHA}
                    changeUsuario={props.changeUsuario}
                  />
                }
              />

              {
                /* /redefinir-email/:uuid */
                paginaSegurancaRedefinirEmail(props)
              }

              {paginaAcessoNegado("/usuario/:uuid",props)}
              {paginaAcessoNegado("/logging",props)}
              {paginaAcessoNegado("/status",props)}
              {paginaAcessoNegado("/usuarios",props)}
              {paginaAcessoNegado("/cadastrar-usuario",props)}
              {paginaAcessoNegado("/reenviar-email/:uuid",props)}
              {paginaAcessoNegado("/redefinir-senha/:uuid",props)}
              {paginaAcessoNegado("/documento/:documentoUUID",props)}
              {paginaAcessoNegado("/redefinir-email",props)}
              {paginaAcessoNegado("/usuario/:uuid/senhas",props)}
              {paginaAcessoNegado("/redefinir-email/:uuid",props)}

              {
                paginaNaoEncontrada(props)
              }

            </>
          ) /* ACESSO LIVRE */
          :
          ( /* ACESSO RESTRITO */
            <>
              <Route
                exact
                path="/"
                element={
                  <Documentos
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    mainError={props.error}
                    setError={props.setError}
                    version={props.version}
                    mobileOpen={props.mobileOpen}
                    setMobileOpen={props.setMobileOpen}
                  />
                }
              />

              <Route
                exact
                path="/usuario/:uuid"
                element={
                  <UsuarioDialog
                    version={props.verion}
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    mainError={props.error}
                    setError={props.setError}
                    changeUsuario={props.changeUsuario}
                  />
                }
              />

              {
                paginasAdministrativas(props)
              }

              <Route
                exact
                path="/redefinir-senha/:uuid"
                element={
                  <PaginaSegurancaDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPaginaSeguranca={TIPOS_PAGINA_DE_SEGURANCA.REDEFINIR_SENHA}
                    changeUsuario={props.changeUsuario}
                  />
                }
              />

              <Route
                exact
                path="/documento/:documentoUUID"
                element={
                  <Campos
                    version={props.version}
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    mainError={props.error}
                    setError={props.setError}
                  />
                }
              />

              <Route
                exact
                path="/redefinir-email"
                element={
                  <EmailDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    version={props.version}
                    mainError={props.error}
                    setError={props.setError}
                    tipoPagina={TIPO_PAGINA.REDEFINIR_EMAIL}
                  />
                }
              />

              <Route
                exact
                path="/usuario/:uuid/senhas"
                element={
                  <SenhasDialog
                    setLoading={props.setLoading}
                    handleMessage={props.handleMessage}
                    error={props.error}
                  />
                }
              />

              {
                /* /redefinir-email/:uuid */
                paginaSegurancaRedefinirEmail(props)
              }

              {
                paginaNaoEncontrada(props)
              }
            </>
          ) /* ACESSO RESTRITO */
        }

      </Routes>
    </BrowserRouter>
  );
}
